module.exports = __webpack_public_path__ + "img/grey_011.6b817a70.png";